<template>

	<div class="control is-horizontal">
		<div class="control-label">
			<label-name labelKey="SITE-APOPOINT-CHILDREN"></label-name>
		</div>

		<div class="control">

			<multiselect
					v-if="!isLoading"
					v-model="selectedPharmacies"
					:options="pharmacies"
					:allow-empty="true"
					:multiple="true"
					:searchable="true"
					:loading="isSearching"
			    :internal-search="falses"
			    :clear-on-select="true"
			    :close-on-select="true"
			    :max-height="600"
			    :show-no-results="true"
			    :hide-selected="true"
					:customLabel="customPharmacyLabel"
					@select="onPharmacySelect"
          @remove="onPharmacyRemove"
					selected-label="aktiv"
					deselect-label="Klick um abzuwählen"
					select-label="Klick für Auswahl"
					placeholder="Nach Apotheken suchen"
					track-by="id"

					style="max-width: 450px;" class="small">

            <span slot="noOptions">Keine Einträge vorhanden</span>
            <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

			</multiselect>

		</div>

	</div>

</template>



<script>
import Multiselect from 'vue-multiselect'


export default {

  name: 'xxx',

  props: {

    siteID: {
      type: Number,
      default: null,
      required: true
    },
    children: {
      type: Array,
      default: () => []
    }

  },

  components: {
    Multiselect
  },

  data() {

    return {
      isSearching: false,
      isLoading: true,
      selectedPharmacies: null,
      pharmacies: [],
    }

  },

  created() {

    this.selectedPharmacies = JSON.parse(JSON.stringify(this.children));
    this.fetchData();

  },

  methods: {

    async onPharmacySelect(pharmacy) {

      const res = await this.axios.put(`${this.$config.api}site/${pharmacy.id}`, { id: pharmacy.id, parent: this.siteID });
      if(res.data) {
        console.log("res add: ", res);
      }

    },

    async onPharmacyRemove(pharmacy) {

      const res = await this.axios.put(`${this.$config.api}site/${pharmacy.id}`, { id: pharmacy.id, parent: null });
      if(res.data) {
        console.log("res delete: ", res);
      }
    },

    async fetchData() {

      // add: and id NOT IN (SITE_ID)
      const res = await this.axios.get(`${this.$config.api}site?fields=id,name,zipcode,city&orderBy=name&filters[parent]=null&filters[id]=!${this.siteID}`);

      this.pharmacies = res.data.site.map((p) => ({ name: p.name, id: p.id, zipcode: p.zipcode }));

      /*
      res.data.site.forEach((s) => {

        this.pharmacies.push({
          id: s.id,
          name: s.name,
          zipcode: s.zipcode
        })

      })
      */

      this.isLoading = false;

    },

    customPharmacyLabel({
      name,
      zipcode = null
    }) {
      return `${name} (PLZ ${zipcode})`;
    },

    closeDropdown(value, id) {
      this.isSearching = false;
    },

    limitText(count) {
      return `and ${count} other countries`
    },

  }

}
</script>
